export const isAssetNameMessage = (value: string) =>
  value.length < 16 && value.split(/\s+/).length < 3;

export const encodeQuestion = (value: string) => {
  const binary = Array.from(new TextEncoder().encode(value), byte =>
    String.fromCharCode(byte)
  ).join('');

  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

export const decodeQuestion = (value: string) => {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    const binary = window.atob(padded);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));

    return new TextDecoder().decode(bytes).trim();
  } catch {
    return '';
  }
};
